// extracted by css-extract-rspack-plugin
export default {"loading":"xNbCV7apcxxgJlBC","blockedBanner":"_Fl7iqy0t_cB90zS"};